/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ enabled: NonNullable<unknown>, total: NonNullable<unknown> }} Org_Models_Enabled_CountInputs */



/**
* | output |
* | --- |
* | "{enabled} / {total} enabled" |
*
* @param {Org_Models_Enabled_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_models_enabled_count = /** @type {((inputs: Org_Models_Enabled_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Models_Enabled_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.enabled} / ${i?.total} aktiviert`)
	return /** @type {LocalizedString} */ (`${i?.enabled} / ${i?.total} enabled`)
});